module.exports = __webpack_public_path__ + "static/media/blip.3b6719e7.wav";